import { render, staticRenderFns } from "./Survey-detail.vue?vue&type=template&id=3332cab2&"
import script from "./Survey-detail.vue?vue&type=script&lang=js&"
export * from "./Survey-detail.vue?vue&type=script&lang=js&"
import style0 from "./Survey-detail.vue?vue&type=style&index=0&id=3332cab2&prod&lang=scss&spaced=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports